import FleetTitle from '@/libs/antd/components/Title';
import { Button, Col, Divider, Form, Result, Row, Select, Table } from 'antd';
import { FC, Fragment, useState } from 'react';
import { useFBDHVisitReportApprovalPage } from './VisitReportApproval';
import ANTD_DEFAULT_PROPS from '@/libs/antd/props';
import TextArea from 'antd/es/input/TextArea';
import rule from '@/libs/antd/rules';
import { useMutation } from '@tanstack/react-query';
import { submitCHVisitReportApproval } from '@/libs/fleet-api/services/visit-reports';
import { useApp } from '@/App';
import FleetModal from '@/libs/antd/components/Modal';

const FBDHVisitReportApprovalForm: FC = () => {
	const { notification, navigate } = useApp();
	const [form] = Form.useForm();
	const { approval, surveyInformation } = useFBDHVisitReportApprovalPage();
	const { approvalHistories } = approval;
	const [showModal, setShowModal] = useState<boolean>(false);

	const handleModalOk = async () => {
		const values = form.getFieldsValue();
		try {
			await submitCHVisitReportApprovalMutation.mutateAsync({
				...(values as Parameters<typeof submitCHVisitReportApproval>[0]),
				surveyId: surveyInformation.id!,
				notes: values.approvalNotes,
			});
			notification.success({
				message: 'Success',
				description: 'Submit approval success',
			});
			navigate('CHVisitReportListPage');
		} catch {
			notification.error({
				message: 'Failed',
				description: 'Submit approval failed',
			});
		}
	};

	const submitCHVisitReportApprovalMutation = useMutation({
		mutationFn: submitCHVisitReportApproval,
	});

	return (
		<Fragment>
			<FleetTitle>Approval History</FleetTitle>
			<Table
				dataSource={
					approvalHistories?.map((record, key) => {
						return { ...record, key };
					}) ?? []
				}
				columns={[
					{
						title: 'No',
						width: 1,
						align: 'center',
						dataIndex: 'no',
					},
					{
						title: 'Name',
						dataIndex: 'approvalBy',
					},
					{
						title: 'Date',
						dataIndex: 'approvalDate',
					},
					{
						title: 'Process',
						dataIndex: 'approvalProcess',
					},
					{
						title: 'Status',
						align: 'center',
						render: (_, record) => {
							return (
								<span
									className={`review-status ${record.approvalStatus.toLowerCase()}`}
								>
									{record.approvalStatus}
								</span>
							);
						},
					},
					{
						title: 'Approval Notes',
						dataIndex: 'approvalNote',
					},
				]}
				bordered
				pagination={false}
				style={{ marginBottom: 20 }}
			/>
			<Form
				{...ANTD_DEFAULT_PROPS.FORM}
				form={form}
				onSubmitCapture={async () => {
					const isFormValid = await form.validateFields();
					if (isFormValid) {
						setShowModal(true);
					}
				}}
			>
				<Row gutter={[40, 20]}>
					<Col span={12}>
						<Form.Item
							name="approvalStatus"
							label="Approval Status"
							rules={[rule.required()]}
						>
							<Select
								allowClear={true}
								options={[{ value: 'Approve' }, { value: 'Reject' }]}
							/>
						</Form.Item>
					</Col>
				</Row>
				<Divider />
				<Form.Item
					name="approvalNotes"
					label="Approval Notes"
					labelCol={{ span: 6 }}
					wrapperCol={{
						style: {
							color: 'blue',
							marginLeft: -10,
						},
					}}
					rules={[rule.required()]}
				>
					<TextArea rows={3} />
				</Form.Item>
				<Button
					type="primary"
					htmlType="submit"
					style={{
						width: 200,
						display: 'block',
						marginLeft: 'auto',
						marginTop: 20,
					}}
					loading={submitCHVisitReportApprovalMutation.isPending}
				>
					SAVE
				</Button>
			</Form>

			<FleetModal
				open={showModal}
				styles={{ footer: { padding: 0 } }}
				okText="SAVE"
				cancelText="CANCEL"
				onCancel={() => setShowModal(false)}
				onOk={handleModalOk}
			>
				<Result
					subTitle={
						<p style={{ color: '#2F2F2F' }}>
							Apakah Anda yakin ingin{' '}
							<b>{form.getFieldValue('approvalStatus')?.toUpperCase()}</b>{' '}
							laporan kunjungan ini?
						</p>
					}
				></Result>
			</FleetModal>
		</Fragment>
	);
};

export default FBDHVisitReportApprovalForm;
